import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2rys9jdptm: FaireBrandEntity = {
  token: "b_2rys9jdptm",
  type: "brand",
  name: "Toynk",
  avatarUrl:
    "https://cdn.faire.com/fastly/509e8bec552427d5a3be0c74bf144067d4055e8c38dd780756d01a2f28bb874c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e1d1e3a8a32f45e1564db4a4c27f91a04e7d0a6d429ec4f3de375a9ce54e1bb3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/509e8bec552427d5a3be0c74bf144067d4055e8c38dd780756d01a2f28bb874c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e1d1e3a8a32f45e1564db4a4c27f91a04e7d0a6d429ec4f3de375a9ce54e1bb3.png",
  location: "Gilberts, IL, USA",
  minimumOrderDollars: 208,
  rating: 4.7,
  reviewCount: 36,
  isInsider: true,
  description:
    "Toynk aims to deliver an ever expanding array of cool costumes, trendy toys and hot collectibles to you, our valued customers. Our team comes together each day, working hard to improve our customers’ experience. It’s not really considered work, when we know that our products bring adventure, joy and happiness to life. It’s no wonder that we love what we do and we love doing it for you. Thank you for shopping with us!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:06.426Z",
    importedBy: "entity-db-cli",
  },
};
